export default "__VITE_ASSET__DLGcHDTf__"